<!--
  ~ Copyright ou © ou Copr. Université de Lorraine, (2022)
  ~
  ~ Direction du Numérique de l'Université de Lorraine - SIED
  ~  (dn-mobile-dev@univ-lorraine.fr)
  ~ JNESIS (contact@jnesis.com)
  ~
  ~ Ce logiciel est un programme informatique servant à rendre accessible
  ~ sur mobile divers services universitaires aux étudiants et aux personnels
  ~ de l'université.
  ~
  ~ Ce logiciel est régi par la licence CeCILL 2.1, soumise au droit français
  ~ et respectant les principes de diffusion des logiciels libres. Vous pouvez
  ~ utiliser, modifier et/ou redistribuer ce programme sous les conditions
  ~ de la licence CeCILL telle que diffusée par le CEA, le CNRS et INRIA
  ~ sur le site "http://cecill.info".
  ~
  ~ En contrepartie de l'accessibilité au code source et des droits de copie,
  ~ de modification et de redistribution accordés par cette licence, il n'est
  ~ offert aux utilisateurs qu'une garantie limitée. Pour les mêmes raisons,
  ~ seule une responsabilité restreinte pèse sur l'auteur du programme, le
  ~ titulaire des droits patrimoniaux et les concédants successifs.
  ~
  ~ À cet égard, l'attention de l'utilisateur est attirée sur les risques
  ~ associés au chargement, à l'utilisation, à la modification et/ou au
  ~ développement et à la reproduction du logiciel par l'utilisateur étant
  ~ donné sa spécificité de logiciel libre, qui peut le rendre complexe à
  ~ manipuler et qui le réserve donc à des développeurs et des professionnels
  ~ avertis possédant des connaissances informatiques approfondies. Les
  ~ utilisateurs sont donc invités à charger et à tester l'adéquation du
  ~ logiciel à leurs besoins dans des conditions permettant d'assurer la
  ~ sécurité de leurs systèmes et/ou de leurs données et, plus généralement,
  ~ à l'utiliser et à l'exploiter dans les mêmes conditions de sécurité.
  ~
  ~ Le fait que vous puissiez accéder à cet en-tête signifie que vous avez
  ~ pris connaissance de la licence CeCILL 2.1, et que vous en avez accepté les
  ~ termes.
  -->

<ng-container *ngTemplateOutlet="getTemplateRef()"></ng-container>

<ng-template #list>
  <ion-row class="next-events-list-style">

    <ion-row *ngIf="isLoading">
      <ion-spinner class="safe-area-lr-ionic-margin" name="dots"></ion-spinner>
    </ion-row>

    <ng-container *ngIf="!isLoading">
      <ion-grid class="events-container">
        <ion-row *ngIf="noNextEvents$ | async" class="ion-padding-bottom">
          <ion-col>
            <ion-note [ngClass]="fontColor()" class="app-text-4">
              {{ "SCHEDULE.WIDGET.NEXT_EVENTS.NO_EVENTS" | translate }}
            </ion-note>
          </ion-col>
        </ion-row>

        <ion-row *ngFor="let event of (nextEvents$ | async); let last = last">
          <ion-col class="ion-no-padding">
            <ion-row *ngIf="displayDateForIds.includes(event.id)" class="event-day">
              <ion-col>
                <ion-text [ngClass]="fontColor()" class="app-title-6 light">
                  {{ event.startDateTime | completeLocalDate }}
                </ion-text>
              </ion-col>
            </ion-row>

            <ion-card [ngClass]="{'last-card': last}">
              <div class="circle-top-left"></div>
              <div class="dashed-line"></div>

              <ion-card-header>
                <ion-card-title [ngClass]="fontColor()" class="app-title-5 light">
                  {{event.startDateTime | localHour}} - {{event.endDateTime | localHour}}
                </ion-card-title>
              </ion-card-header>

              <ion-card-content>
                <ion-row>
                  <ion-col>
                    <ion-text [ngClass]="fontColor()" class="app-title-5">{{event.course.label}}</ion-text>

                    <ion-row class="ion-align-items-start card-labels" *ngFor="let room of event.rooms">
                      <ion-col size="auto" class="ion-no-padding">
                        <ion-icon [ngClass]="[fontColor(), 'card-labels-icons']" name="business-outline" aria-hidden="true"></ion-icon>
                      </ion-col>
                      <ion-col class="ion-no-padding">
                        <ion-text [ngClass]="fontColor()" class="app-title-6 light">{{room.label}} - {{room.building}}</ion-text>
                      </ion-col>
                    </ion-row>

                    <ion-row class="ion-align-items-start card-labels" *ngFor="let teacher of event.teachers">
                      <ion-col size="auto" class="ion-no-padding">
                        <ion-icon [ngClass]="fontColor()" class="card-labels-icons" name="man-outline" aria-hidden="true"></ion-icon>
                      </ion-col>
                      <ion-col class="ion-no-padding">
                        <ion-text [ngClass]="fontColor()" class="app-title-6 light">{{teacher.displayname}}</ion-text>
                      </ion-col>
                    </ion-row>

                    <ion-row class="ion-align-items-start card-labels" *ngIf="event.course.url">
                      <ion-col size="auto" class="ion-no-padding">
                        <ion-icon [ngClass]="fontColor()" class="card-labels-icons" name="link-outline" aria-hidden="true"></ion-icon>
                      </ion-col>
                      <ion-col class="ion-no-padding">
                        <ion-text [ngClass]="fontColor()" class="app-title-6 light">{{ event.course.url | truncate:35 }}</ion-text>
                      </ion-col>
                    </ion-row>
                  </ion-col>
                </ion-row>
              </ion-card-content>
            </ion-card>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ng-container>

  </ion-row>
</ng-template>


<ng-template #slider>
  <ion-row class="next-events-slider-style">

    <ion-row *ngIf="isLoading === true">
      <ion-spinner class="safe-area-lr-ionic-margin" name="dots"></ion-spinner>
    </ion-row>

    <ng-container *ngIf="isLoading === false">

      <ion-grid class="empty-container" *ngIf="(noNextEvents$ | async) === true; else sliderInnerContainer">
        <ion-row class="ion-padding-bottom">
          <ion-note [ngClass]="fontColor()" class="app-text-4">
            {{ "SCHEDULE.WIDGET.NEXT_EVENTS.NO_EVENTS" | translate }}
          </ion-note>
        </ion-row>
      </ion-grid>
      <ng-template #sliderInnerContainer>
        <ion-row class="events-container">
          <ion-card *ngFor="let event of (nextEvents$ | async) let last = last" class="ion-no-margin slider-theme-color">
            <ion-card-content>
              <ion-row [ngStyle]="{'border-left-color': event.course.color}" class="event-day-hour">
                <ion-text class="hour app-title-2 slider-font-color">{{event.startDateTime | localHour}} - {{event.endDateTime | localHour}}</ion-text>
                <ng-container *ngIf="(event.startDateTime | completeLocalDate) as completeLocalDate">
                  <ion-row class="day app-text-4">
                    <ion-text class="slider-font-color">{{completeLocalDate | slice: 0:completeLocalDate.indexOf(' ')}}</ion-text>
                    <ion-text class="slider-font-color">{{completeLocalDate | slice: completeLocalDate.indexOf(' ')}}</ion-text>
                  </ion-row>
                </ng-container>
              </ion-row>
              <ion-text class="app-title-5 event-label slider-font-color">{{event.course.label}}</ion-text>
              <ion-row class="event-additional">
                <ion-row class="ion-align-items-center card-labels" *ngFor="let room of event.rooms">
                  <ion-icon class="card-labels-icons slider-font-color" name="business-outline" aria-hidden="true"></ion-icon>
                  <ion-text class="app-title-6 light slider-font-color">{{room.label}}<span *ngIf="room.building"> - {{room.building}}</span></ion-text>
                </ion-row>
                <ng-container *ngIf="event.teachers.length <= 2; else limitTeachers">
                  <ion-row class="ion-align-items-center card-labels" *ngFor="let teacher of event.teachers">
                    <ion-icon class="card-labels-icons slider-font-color" name="man-outline" aria-hidden="true"></ion-icon>
                    <ion-text class="app-title-6 light slider-font-color">{{teacher.displayname}}</ion-text>
                  </ion-row>
                </ng-container>
                <ng-template #limitTeachers>
                  <ion-row class="ion-align-items-center card-labels">
                    <ion-icon class="card-labels-icons slider-font-color" name="man-outline" aria-hidden="true"></ion-icon>
                    <ion-text class="app-title-6 light slider-font-color">{{event.teachers[0].displayname}} (+ {{event.teachers.length - 1}} {{ "SCHEDULE.WIDGET.NEXT_EVENTS.LIMIT_TEACHERS" | translate }})</ion-text>
                  </ion-row>
                </ng-template>
                <ion-row class="ion-align-items-center card-labels" *ngIf="event.course.url">
                  <ion-icon class="card-labels-icons slider-font-color" name="link-outline" aria-hidden="true"></ion-icon>
                  <ion-text class="app-title-6 light slider-font-color">{{ event.course.url | truncate:35 }}</ion-text>
                </ion-row>
              </ion-row>
            </ion-card-content>
          </ion-card>

        </ion-row>
      </ng-template>
    </ng-container>

  </ion-row>
</ng-template>
